// extracted by mini-css-extract-plugin
export default {"container":"nN-z","topReviewHeading":"oN-z","criticalReview":"pN-z","favorableReview":"qN-z","vsSeparator":"rN-z"};